import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  manualCommunicationState,
  previewTemplatePayloadType,
  selectedManualCommunication,
} from '../types'

const initialState: manualCommunicationState = {
  selected: null,
}

const manualCommunicationSlice = createSlice({
  name: 'manualCommunication',
  initialState: initialState,
  reducers: {
    updateSelectedManualCommunicationState: (
      state: manualCommunicationState,
      action: PayloadAction<selectedManualCommunication | null>
    ) => {
      state.selected = action.payload
    },

    resetSelectedManualCommunicationState: (
      state: manualCommunicationState
    ) => {
      state.selected = null
    },

    getPreviewTemplateDataView: (
      state: manualCommunicationState,
      _action: PayloadAction<previewTemplatePayloadType>
    ) => {
      return state
    },

    getPreviewTemplateDataEdit: (
      state: manualCommunicationState,
      _action: PayloadAction<previewTemplatePayloadType>
    ) => {
      return state
    },
  },
})

export const {
  getPreviewTemplateDataView,
  getPreviewTemplateDataEdit,
  resetSelectedManualCommunicationState,
  updateSelectedManualCommunicationState,
} = manualCommunicationSlice.actions
export default manualCommunicationSlice.reducer
